import { atom, WritableAtom } from 'jotai';
import type { Range } from '@tiptap/core';

const _queryAtom = atom('');
export const queryAtom = atom('', (get, set, newValue: string) => {
  set(_queryAtom, newValue);
}) as WritableAtom<string, [string], void>;

export const rangeAtom = atom<Range | null>(null as Range | null) as WritableAtom<
  Range | null,
  [Range | null],
  void
>;
